module.exports = __webpack_public_path__ + "img/deactivation-success.0b549bde.svg";